<template src="./template.html"></template>

<script>
  import { mapFields } from 'vuex-map-fields'

  export default {
    name: 'PaypalCheckout',
    props: {
      total: {
        default: 0,
        type: Number,
      },
    },
    computed: {
      ...mapFields('cart', [
        'enable_paypal_paylater',
        'cart_login',
        'cart_error',
      ]),
      configurePayPalLaterParameter() {
        return this.enable_paypal_paylater ? '&enable-funding=paylater' : ''
      },
    },
    mounted() {
      this.loadPaypalSDK()
    },
    methods: {
      loadPaypalSDK() {
        const checkoutScript = document.createElement('script')
        checkoutScript.src = 'https://www.paypalobjects.com/api/checkout.js'
        document.head.append(checkoutScript)
        const self = this
        const script = document.createElement('script')
        script.setAttribute('data-namespace', 'paypal_paylater')
        script.src =
          `https://www.paypal.com/sdk/js?client-id=${window.config.paypal_client_id}&currency=${window.config.currency}&locale=${window.config.paypal_locale}&intent=capture&commit=false&components=buttons,messages${this.configurePayPalLaterParameter}&disable-funding=sepa,card`
        document.head.append(script)
        script.onload = _ => {
          self.initPaypalButton(self)
        }
      },
      initPaypalButton(self) {
        const FUNDING_SOURCES = [window.paypal_paylater.FUNDING.PAYPAL]
        // Loop over each funding source / payment method
        FUNDING_SOURCES.forEach(fundingSource => {
          // Initialize the buttons
          const button = window.paypal_paylater.Buttons({
            style: {
              color: 'gold',
              layout: 'horizontal',
              shape: 'pill',
              label: 'checkout',
              size: 'responsive',
              tagline: false,
            },
            // commit: true,
            // fundingSource,
            createOrder: (data, actions) => {
              // This function sets up the details of the transaction, including the amount and line item details.
              return actions.order.create({
                purchase_units: [
                  {
                    amount: {
                      // the value will be automatically change, when the total will be changed
                      value: Number(self.total).toFixed(2),
                    },
                  },
                ],
              })
            },
            onError: function(err) {
              // Show an error page here, when an error occurs
              document.location.href = this.cart_error || `/${this.$i18n.formatedLocale}/checkout/purchase?err=pp1`
            },
            onApprove: (data, actions) => {
              const isPaylater = data.paymentSource === 'paylater'
              document.querySelector('body').classList.add('wait')
              document.querySelector('div#start').style.opacity = 0.1
              const submitData = {
                id: data.orderID,
                pid: data.payerID,
              }
              this.$emit('onPaypalPayment', submitData, isPaylater)
            },
          })

          // Check if the button is eligible
          if (button && button.isEligible()) {
          // Render the standalone button for that funding source
            button.render('#paypal-button-container')
          }
        })

      },
    },
  }
</script>
